import { usePartialSubscription } from '../stateData/hooks'

export const useIsFlip = (): boolean => {
  const partialSubscriptionState = usePartialSubscription()
  const flowName = partialSubscriptionState.data?.flowName || ''

  return flowName.includes('ftm') || flowName.includes('flip')
}
